import { Component, computed, inject } from '@angular/core';
import { HeaderComponent } from '../../common-components/header/header.component';
import { MainCardComponent } from '../../common-components/main-card/main-card.component';
import { NgForOf } from '@angular/common';
import { AssignmentService } from '../../services/assignment.service';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-assignments-page',
  standalone: true,
  imports: [
    HeaderComponent,
    MainCardComponent,
    NgForOf,
    TranslocoDirective
  ],
  templateUrl: './assignments-page.component.html',
  styleUrl: './assignments-page.component.scss'
})
export class AssignmentsPageComponent {
  protected audits = computed(() => this.assignmentService.upcomingAudits())

  private readonly assignmentService = inject(AssignmentService);
}
